export const getRaspiskaStyles = () => `
<style>
* {
  padding: 0;
  margin: 0;
  border: 0;
  -webkit-tap-highlight-color: transparent;
}
*,
*:before,
*:after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
:focus,
:active {
  outline: none;
}
a:focus,
a:active {
  outline: none;
  text-decoration: none;
}
nav,
footer,
header,
aside {
  display: block;
}

table {
  font-size: inherit;
}
html,
body {
  font-family: 'TT Norms', sans-serif;
  height: 100%;
  width: 100%;
  font-size: 100%;
  line-height: 1;
  font-size: 16px;
  -ms-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
input,
button,
textarea {
  font-family: inherit;
  line-height: inherit;
}
input::-ms-clear {
  display: none;
}
button {
  cursor: pointer;
}
button::-moz-focus-inner {
  padding: 0;
  border: 0;
}
a,
a:visited {
  text-decoration: none;
  color: inherit;
}
a:hover {
  text-decoration: none;
}
ul li {
  list-style: none;
}
img {
  width: 100%;
}
/*--------------------*/

@media print {
  @page {
    size: A4 portrait;
    margin-top: 0.5cm;
  }

  body {
    visibility: hidden;
  }

  body .mainContainer {
    visibility: visible;
  }
}

.mainContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.mainContainer:first-of-type {
  margin-bottom: 15px;
}

.mb-2 {
  margin-bottom: 2px;
}

.mb-5 {
  margin-bottom: 5px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-15 {
  margin-bottom: 15px;
}

.h-15 {
  font-size: 1.5rem;
}

.h-14 {
  font-size: 1.4rem;
}

.h-13 {
  font-size: 1.3rem;
}

.h-12 {
  font-size: 1.2rem;
}

.h-11 {
  font-size: 1.1rem;
}

.h-09 {
  font-size: 0.9rem;
}

.h-08 {
  font-size: 0.8rem;  
}

.bold {
  font-weight: bold !important;
}

.curlyBorder {
  border: 1px solid black;
  border-radius: 15px;
}

.tableRounded {
  border-collapse: separate;
  border: 1px solid black;
  border-radius: 8px;
  overflow: hidden;
  border-spacing: 0;
}

.tableRounded tr:last-child th,
.tableRounded tr:last-child td {
  border: none;
}

.textPlaceholderFIO {
  font-size: 0.5rem;
  color: rgba(0, 0, 0, 0.2);
  font-weight: bold;
  letter-spacing: 0.1rem;
}

.textPlaceholderPayment {
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.2);
  font-weight: bold;
  letter-spacing: 0.1rem;
}

.textPlaceholderSeal {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.2);
  font-weight: 900;
  letter-spacing: 0.1rem;
}

.textPlaceholderSeal:last-of-type {
  text-align: center;
}

.bigTdText {
  font-weight: bold;
  letter-spacing: 0.05rem;
  font-size: 0.8rem !important;
}

.bigTdTextTd {
  font-weight: bold;
  letter-spacing: 0.08rem;
  font-size: 1rem;
}

.invertedCell {
  background: black;
  color: white;
}

.emptyLineWrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.emptyLine {
  border-top: 1px solid black;
  width: 40px;
}

body {
  margin: 0 auto;
  height: 100%;
}
.container {
  font-size: 0.6rem;
}
/* header */
.header {
  position: relative;
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  margin-bottom: 6px;
}

.header_docInfo {
  height: 68px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header_shippingInfo {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.carrier {
}

.header_icon {
  content: url('data:image/png;base64,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');
  position: absolute;
  top: 0px;
  left: 100%;
  transform: translateX(-120%);
  width: 110px;
  height: 90px;
}

/* end header */

/* peopleInfo */
.peopleInfo {
  display: flex;
  gap: 4px;
  margin-bottom: 6px;
}

.peopleInfo_table {
  flex-grow: 1;
}

.peopleInfo_table__th,
.peopleInfo_table__td {
  font-size: 0.45rem;
  text-align: left;
  padding: 2px;
  border-bottom: 1px solid black;
}

.peopleInfo_table__th {
  padding-left: 10px;
}

.peopleInfo_table__td {
  padding-right: 5px;
}

.peopleInfo_table__td__wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
}

.peopleInfo_table__td__wrapper__info {
  font-size: 0.55rem;
}

.peopleInfo_table__td__wrapper__info_custom {
  line-height: 0.65rem;
  font-size: 0.75rem;
}

.peopleInfo_table:last-of-type {
  align-self: flex-end;
}

.peopleInfo_table__th_wrapper {
  display: flex;
  align-items: center;
  gap: 2px;
}

.boxCross {
  font-size: 0.5rem;
  border: 1px solid black;
  border-radius: 3px;
  width: 13px;
  height: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* end peopleInfo */

/* cargoInfo */

.cargoInfo {
  margin-bottom: 6px;
}

.cargoInfo_table {
  width: 100%;
}
.cargoInfo_table th,
.cargoInfo_table td {
  text-align: center;
  padding: 2px;
}

.cargoInfo_table th {
  font-size: 0.5rem;
}

.cargoInfo_table td:nth-child(odd),
.cargoInfo_table th:nth-child(odd) {
  background-color: #dddddd;
}

.cargoInfo_table_firstRow th {
  padding-bottom: 2px;
}

.cargoInfo_table_firstRow td {
  padding-bottom: 10px;
}

.cargoInfo_secondRow {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-columns: 1fr;
  gap: 4px;
}

.infoBlock {
  padding: 8px;
  min-width: 105px
}

.infoBlock_items {
  font-size: 0.5rem;
}

.cargoInfo_secondRow .infoBlock {
  grid-column: 1 / 2;
}

.cargoInfo_secondRow_table {
  grid-column: 2 / 8;
}

.cargoInfo_secondRow_table td {
  width: 12.5%;
  text-align: center;
  padding: 0;
}

.extraServices {
  font-weight: bold;
  font-size: 0.6rem;
}

.extraServicesType {
  font-size: 0.4rem;
}

.cargoInfo_secondRow_table td > p {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

.cargoInfo_table__bottomInfo {
  margin-top: auto;
  border-top: 1px solid black;
  background-color: #fff;
  border-right: 1px solid black;
  font-size: 0.5rem;
  display: flex;
  align-items: center;
}

.cargoInfo_table__bottomInfo p {
  height: 15px;
  line-height: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
}

.cargoInfo_table__bottomInfo_borderLeft {
  border-radius: 0 0 0 8px;
}

.cargoInfo_table__bottomInfo_borderRight {
  border-radius: 0 0 8px 0;
}

/* end cargoInfo */

/* footer */
.footerGrid {
  display: grid;
  grid-auto-columns: 1fr;
  gap: 4px;
  grid-template-areas:
    'infoBlock payment payment payment payment payment payment seal seal'
    'infoBlock signature signature signature signature signature signature seal seal'
    'warningInfo warningInfo warningInfo warningInfo warningInfo warningInfo warningInfo seal seal';
}
.infoBlockGrid {
  grid-area: infoBlock;
}

.payment {
  grid-area: payment;
  padding-inline: 6px;
  display: flex;
  align-items: center;
}

.payment_qrInfo {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.payment_qrLabel {
  font-size: 0.9rem;
}

.payment_qrImg {
  width: 40px;
  height: 40px;
}

.payment_table {
}

.payment_table td,
.payment_table th {
  padding: 1px;
  font-weight: normal;
  font-size: 0.7rem;
}

.payment_table .payment_amount {
  padding: 0;
  font-size: 0.9rem;
}

.payment_info {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-grow: 1;
}

.payment_way {
  margin: 0 15px 0 0;
}

.signature {
  grid-area: signature;
}
.signature_row {
}

.payment_tick {
  font-size: 0.8rem;
  font-weight: 200;
  opacity: 0.7;
}

.signature_row__first {
  padding: 3px 15px 3px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid black;
}

.signature_row__second {
  padding: 3px 15px 3px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.signature_row_second_place {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 4;
}

.signature_row_second_place p:first-of-type {
  margin-right: 3px;
}

.warningInfo {
  text-align: justify;
  opacity: 0.8;
  font-size: 0.4rem;
  grid-area: warningInfo;
}

.seal {
  grid-area: seal;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, 1fr);
  justify-items: center;
}

.seal p {
  font-size: 0.8rem;
  letter-spacing: -0.3px;
}

.seal p:first-child {
  align-self: end;
}
.seal p:last-child {
  margin-bottom: 10px;
  align-self: end;
}
/* end footer */

</style>
`;
